/**
 * GTM events triggered on the Data Layer by this library.
 * */
export enum GtmEventNames {
  // This event is triggered when the CDP profile setup is complete. Remarks : Used in tests
  CdpProfileSetupCompleted = "gtmDataSyncLib_cdpProfileSetupCompleted",
  // Used by the library to indicate that the library is loaded and the user setup is complete
  GTMDataSyncLibSetupDone = "gtmDataSyncLib_setup_done",
  // This event is triggered when the user has seen a certain amount pages on IciTele section.
  IciTeleEngagementPageView = "gtmDataSyncLib_iciTeleEngagementPageView",
  // This event is triggered when the user has spent a certain amount of time on IciTele section.
  IciTeleEngagementTimeSpent = "gtmDataSyncLib_iciTeleEngagementTimeSpent",
  // This event is triggered when the user has seen a certain amount pages on Ohdio section.
  OhdioEngagementPageView = "gtmDataSyncLib_ohdioEngagementPageView",
  // This event is triggered when the user has spent a certain amount of time on Ohdio section.
  OhdioEngagementTimeSpent = "gtmDataSyncLib_ohdioEngagementTimeSpent",
  // Used by lotame tags.
  SetUserInfoDone = "set_userInfo_done",
  // Used to trigger readjs_cbc_module (it needs the RC_Visitor_Id)
  UserIdExchangeDone = "user_id_exchange_done",
}
